import * as byRefFuncLibrary from './byRefFunctionLibrary'
import type { BeckyFunctionLibrary, BeckyModel, BeckyRequestPayload, RefBeckyModel } from '@wix/thunderbolt-becky-root'
import { flattenStructure } from '@wix/thunderbolt-becky-root'
import { Data, PageJson, Structure } from '@wix/thunderbolt-becky-types'
import { resolveByRef } from '@wix/thunderbolt-byref/src/resolveByRef.site-assets'

import _ from 'lodash'
import { createRemoteRefsFetcher } from './resolveRemoteRefs'

const byRefModelFactory = require('./carmi/byRefs.carmi')

const hasUnresolvedByRefComp = (structure: Structure) => {
	return _(structure)
		.values()
		.filter((comp) => !!comp.componentType && comp.componentType.endsWith('RefComponent'))
		.map('components')
		.some(_.isEmpty)
}

const resolveByRefRunner = (
	fetchRemoteRefs: ReturnType<typeof createRemoteRefsFetcher>,
	useByRefsis: boolean = false
) => async (model: RefBeckyModel, funcLib: BeckyFunctionLibrary): Promise<{ structure: Structure; data: Data }> => {
	if (!hasUnresolvedByRefComp(model.structure)) {
		return model
	}

	const widgetTemplatesStore = await fetchRemoteRefs(model.data.document_data)

	const res = (useByRefsis ? resolveByRef : byRefModelFactory)({ ...model, widgetTemplatesStore }, funcLib) as {
		structure: Structure
		data: Data
		translations: PageJson['translations']
	}

	return { ...model, ...res }
}

export const resolveByRefComponents = (
	beckyModel: BeckyModel,
	masterPageStructure: Structure,
	masterPageData: Data,
	functionLibrary: BeckyFunctionLibrary,
	requestPayload: BeckyRequestPayload
): Promise<{ structure: Structure; data: Data; translations: PageJson['translations'] }> =>
	functionLibrary.runAsyncAndReport(async () => {
		const funcLib = { ...functionLibrary, ...byRefFuncLibrary, flattenStructure }
		const resolveGhosts = requestPayload.resolveGhosts === 'true'
		const useByRefsis = beckyModel.experiments['specs.thunderbolt.byRefsis'] === true

		const fetchRemoteRefs = createRemoteRefsFetcher(
			funcLib.fetchUrl.bind(functionLibrary),
			beckyModel.clientSpecMap,
			beckyModel.publicTopology,
			requestPayload
		)

		const masterPageResolved: any = await resolveByRefRunner(fetchRemoteRefs, useByRefsis)(
			{
				...beckyModel,
				structure: masterPageStructure,
				data: masterPageData,
				masterPageStructure,
				masterPageData,
				requestPayload,
				resolveGhosts,
				widgetTemplatesStore: { mobile: {}, desktop: {} },
			},
			funcLib
		)
		return beckyModel.pageCompId === 'masterPage'
			? masterPageResolved
			: resolveByRefRunner(fetchRemoteRefs, useByRefsis)(
					{
						...beckyModel,
						masterPageStructure: masterPageResolved.structure,
						masterPageData: masterPageResolved.data,
						requestPayload,
						resolveGhosts,
						widgetTemplatesStore: { mobile: {}, desktop: {} },
					},
					funcLib
			  )
	}, 'tb-byRef-resolving')
